<script setup lang="ts">
import {onMounted, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import {useMainStore} from "@/Stores/store";
import {registerUser} from "@/Services/auth";
import {saving} from "@/Composables/api";
import {Button, Checkbox, InputText, Label, Password} from "@/Components/Library";
import {Messages} from "@/Components/Forms";
import {getAuthInvitation} from "@/Services/invitations";
import TermsAndConditionsDialog from "./TermsAndConditionsDialog.vue";

const router = useRouter();
const $store = useMainStore();
console.log(router.currentRoute.value.query.invitation);

const form = reactive({
    first_name: null,
    last_name: null,
    nickname: null,
    email: null,
    password: null,
    password_confirmation: null,
    terms_accepted: false,
});

const invitation = ref();
const showTerms = ref(false);
if (router.currentRoute.value.query.invitation) {
    getAuthInvitation(router.currentRoute.value.query.invitation).then(({data}) => {
        console.log(data);
        invitation.value = data;
        form.email = data?.email;
        form.first_name = data?.first_name;
        form.last_name = data?.last_name;
    });
} else {
    // router.push({name: "login"});
}

const errors = ref<{
    first_name?: string[];
    last_name?: string[];
    email?: string[];
    password?: string[];
    password_confirmation?: string[];
    server?: string[];
}>({});

const validate = () => {
    if (!form.first_name) {
        errors.value.first_name = ["First name is required"];
    }
    if (!form.last_name) {
        errors.value.last_name = ["Last name is required"];
    }
    if (!form.email) {
        errors.value.email = ["Email is required"];
    }
    if (!form.password) {
        errors.value.password = ["Password is required"];
    }
    if (!form.password_confirmation) {
        errors.value.password_confirmation = ["Password confirmation is required"];
    }
    if (form.password !== form.password_confirmation) {
        errors.value.password_confirmation = ["Passwords do not match"];
    }

    return !Object.values(errors.value).length;
};

const save = async () => {
    errors.value = {};
    // if (!validate(form.data())) {
    //     return;
    // }
    const {data} = await registerUser(form, invitation.value?.id);
    console.log(data);
    if (data.errors) {
        errors.value = data.errors;
    }
    try {
        sessionStorage.setItem("user", data.id);
        $store.user = data;

        if (invitation.value) {
            if (invitation.value.to === "group" && invitation.value?.for?.id) {
                await router.push({
                    name: "groups.invitations.show",
                    params: {group: invitation.value.for.id, invitation: invitation.value.id},
                });
            } else {
                await router.push({name: "contacts.index"});
            }
            return;
        }

        await router.push({name: "feed"});
    } catch (e) {
        // alert("An error occurred: " + e.response?.data?.message);
        console.log(e);
        await router.push({name: "feed"});
    }
};

// const cfTurnstile = ref(null);
// const cfTurnstileKey = import.meta.env.VITE_CF_TURNSTILE_SITE_KEY;
onMounted(() => {
    // @ts-ignore
    // turnstile.render(cfTurnstile.value, {
    //     sitekey: cfTurnstileKey,
    //     appearance: "interaction-only",
    // });
});
</script>
<template>
    <div>
        <!--        <div class="flex justify-center gap-4">-->
        <!--            <router-link :to="{name: 'login'}" class="mb-4 px-3 pb-1 text-xl font-bold">Log In</router-link>-->
        <!--            <router-link :to="{name: 'register'}" class="mb-4 border-b-2 border-white px-3 pb-1 text-xl font-bold">-->
        <!--                Sign up-->
        <!--            </router-link>-->
        <!--        </div>-->
        <div v-if="invitation">
            <!--            {{ invitation }}-->
            <div class="mb-6 rounded-md bg-askr-green p-4 text-white">
                <p class="mb-1 text-lg">
                    <span>You have been invited to join</span>
                    <span v-if="invitation.to === 'group'">
                        the group
                        <span class="font-semibold">{{ invitation.for.name }}</span>
                    </span>
                    <span v-else>
                        <span>&nbsp;</span>
                        <span class="font-black tracking-tighter">ASKr</span>
                    </span>
                    by
                    <span class="font-semibold">{{ invitation.user.first_name }} {{ invitation.user.last_name }}</span>
                </p>
                <p class="text-lg">Please complete the form below to accept their invitation.</p>
            </div>
        </div>
        <form @submit.prevent="save" class="w-full">
            <div class="mb-6">
                <div class="mb-4 flex flex-col">
                    <Label for="first_name" class="mb-1" required>First Name</Label>
                    <InputText
                        class="bg-transparent text-white dark:border-stone-300 dark:bg-transparent dark:placeholder:text-stone-400"
                        id="first_name"
                        name="first_name"
                        placeholder="First Name"
                        type="text"
                        required
                        autofocus
                        autocomplete="first_name"
                        fluid
                        v-model="form.first_name"
                    />
                    <small v-if="errors.first_name" class="mt-2 text-red-500">{{ errors.first_name }}</small>
                </div>
                <div class="mb-4 flex flex-col">
                    <Label for="last_name" class="mb-1" required>Last Name</Label>
                    <InputText
                        class="bg-transparent text-white dark:border-stone-300 dark:bg-transparent dark:placeholder:text-stone-400"
                        id="last_name"
                        name="last_name"
                        placeholder="Last Name"
                        type="text"
                        required
                        autofocus
                        autocomplete="last_name"
                        fluid
                        v-model="form.last_name"
                    />
                    <small v-if="errors.last_name" class="mt-2 text-red-500">{{ errors.last_name }}</small>
                </div>
                <div class="mb-8">
                    <div class="mb-4 flex flex-col">
                        <Label for="nickname" class="mb-1" required>Nickname</Label>
                        <InputText
                            class="bg-transparent text-white dark:border-stone-300 dark:bg-transparent dark:placeholder:text-stone-400"
                            id="nickname"
                            name="nickname"
                            placeholder="Nickname"
                            type="text"
                            required
                            autofocus
                            autocomplete="nickname"
                            fluid
                            v-model="form.nickname"
                        />
                        <small v-if="errors.nickname" class="mt-2 text-red-500">{{ errors.first_name }}</small>
                        <span v-else class="mt-1 text-xs text-white">
                            This will be your name displayed in public groups
                        </span>
                    </div>
                </div>
                <div class="mb-8 flex flex-col">
                    <Label for="email" class="mb-1" required>Email</Label>
                    <InputText
                        class="bg-transparent text-white dark:border-stone-300 dark:bg-transparent dark:placeholder:text-stone-400"
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Email"
                        required
                        autocomplete="username"
                        fluid
                        v-model="form.email"
                    />
                    <small v-if="errors.email" class="mt-2 text-red-500">{{ errors.email }}</small>
                </div>
            </div>
            <div class="mb-4">
                <div class="mb-4 flex flex-col">
                    <Label for="password" class="mb-1" required>Password</Label>
                    <Password
                        inputId="password"
                        name="password"
                        placeholder="Password"
                        required
                        autocomplete="new-password"
                        fluid
                        toggleMask
                        :feedback="false"
                        inputClass="bg-transparent text-white dark:border-stone-300 dark:bg-transparent dark:placeholder:text-stone-400"
                        v-model="form.password"
                    />
                    <small v-if="errors.password" class="mt-2 text-red-500">{{ errors.password }}</small>
                </div>
                <div class="flex flex-col">
                    <Label for="password_confirmation" class="mb-1" required>Confirm Password</Label>
                    <Password
                        inputId="password_confirmation"
                        name="password_confirmation"
                        placeholder="Confirm Password"
                        required
                        autocomplete="new-password"
                        fluid
                        toggleMask
                        :feedback="false"
                        inputClass="bg-transparent text-white dark:border-stone-300 dark:bg-transparent dark:placeholder:text-stone-400"
                        v-model="form.password_confirmation"
                    />
                    <small v-if="errors.password_confirmation" class="mt-2 text-red-500">
                        {{ errors.password_confirmation[0] }}
                    </small>
                </div>
            </div>
            <div class="mb-4 flex items-center justify-center gap-2 text-xs">
                <!-- accept terms -->
                <Checkbox
                    inputId="terms_accepted"
                    v-model="form.terms_accepted"
                    :binary="true"
                    required
                    title="Please accept the terms and conditions to proceed"
                />
                <label for="terms_accepted" class="mr-2">
                    I accept the
                    <button type="button" @click="showTerms = true" class="underline">terms and conditions</button>
                </label>
            </div>
            <div class="mb-16 flex flex-col items-center justify-end" v-auto-animate>
                <!--            <div class="flex items-center justify-center">-->
                <!--                <div-->
                <!--                    class="cf-turnstile"-->
                <!--                    ref="cfTurnstile"-->
                <!--                    :data-sitekey="cfTurnstileKey"-->
                <!--                ></div>-->
                <!--            </div>-->
                <Messages bag="registerForm" class="mb-6" />
                <Button
                    type="submit"
                    :loading="!!saving"
                    class="mb-4 w-full bg-askr-green text-white hover:brightness-110 lg:max-w-sm"
                >
                    Register
                </Button>
                <RouterLink :to="'/login'">Already registered?</RouterLink>
            </div>
        </form>
        <TermsAndConditionsDialog v-model="showTerms" />
    </div>
</template>
<style scoped></style>
